<template>
  <v-card
    flat
    hover
    height="200px"
    color="transparent"
  >
    <v-layout align-center justify-end row fill-height>
      <v-flex md12 text-md-center>
        <v-img :src="section_image" height="200px" contain></v-img>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    section_image:{
      type: String,
      required: true
    }
  }
}
</script>